module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.12/_next/static/images/selo-sem-luz-dc06e0c75c31bdf487d2e2e571abc6e2.webp";